const ValueConstants = {
  // keycodes
  LEFT_ARROW_KEYCODE: 37,
  RIGHT_ARROW_KEYCODE: 39,
  ESC_KEYCODE: 27,
  ENTER_KEYCODE: 13,
  TAB_KEYCODE: 9,
  UP_ARROW_KEYCODE: 38,
  DOWN_ARROW_KEYCODE: 40,

  // user tracking
  USER_MILESTONE_35: 35000, // milliseconds
  USER_MILESTONE_60: 60000, // milliseconds
  USER_MILESTONE_90: 90000, // milliseconds

  // search
  STATE_PATTERN:
    /-(AL|AK|AR|AZ|CA|CO|CT|DC|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY)-/i, //eslint-disable-line
  ZIP_PATTERN: /-(\d{5})-/,
};

export default ValueConstants;
